import React from 'react';
import s from './CustomGreenCheckbox.module.css';
type Props = {
	labelTxt: string;
	id: string;
	name: string;
	required: boolean;
	checked: boolean;
	setFieldValue: (name: string, b: boolean | string) => void;
};
const CustomGreenCheckbox: React.FC<Props> = ({
	labelTxt,
	id,
	name,
	required,
	checked,
	setFieldValue,
}) => {
	required = Boolean(required);
	if (name) {
		id = name + '-' + id;
	} else {
		name = id;
	}
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (name !== 'status') {
			setFieldValue(name, event.target.checked);
		} else {
			setFieldValue(name, event.target.checked ? 'notshipped' : '');
		}
	};
	return (
		<div className={s.checkBoxContainer}>
			<input
				className={s.checkboxInput}
				name={name}
				checked={checked}
				onChange={handleChange}
				required={required}
				id={id}
				type="checkbox"
			/>
			<label htmlFor={id}>{labelTxt}</label>
		</div>
	);
};

export default CustomGreenCheckbox;
